import Block from "@components/block"
import award1Img from "@imagesgz/content/award1.jpg"
import award2Img from "@imagesgz/content/award2.jpg"
import award3Img from "@imagesgz/content/award3.jpg"
import award4Img from "@imagesgz/content/award4.jpg"
import award5Img from "@imagesgz/content/award5.jpg"
import award6Img from "@imagesgz/content/award6.jpg"
import gamesAppImg from "@imagesgz/content/games-app.png"
import gamesPcImg from "@imagesgz/content/games-pc.png"
import indieAppImg from "@imagesgz/content/indie-app.png"
import indiePcImg from "@imagesgz/content/indie-pc.png"
import booomImg from "@imagesgz/content/gamejam.jpeg"
import ruleAppImg from "@imagesgz/content/play-rule-app.png"
import rulePcImg from "@imagesgz/content/play-rule-pc.png"
import bgImg from "@imagesgz/play-bg.png"
import playTitleImg from "@imagesgz/title-play.png"
import playTitleAppImg from "@imagesgz/title-play-app.png"
import Box, { BoxTitle } from "@src/components/box"
import CardButton from "@src/components/button"
import ResponsiveImage from "@src/components/responsiveContent/image"
import Title from "@src/components/title"
import React, { useEffect, useRef } from "react"
import * as styles from "./play.module.scss"

const awards = [
  {
    image: award1Img,
    title: "奖品：次世代主机",
  },
  {
    image: award3Img,
    title: "奖品：机组乐园 方巾",
  },
  {
    image: award4Img,
    title: "奖品：帆布袋",
  },
  {
    image: award5Img,
    title: "奖品：限定棒球外套",
  },
  {
    image: award2Img,
    title: "奖品：机组乐园 棋子",
  },
  {
    image: award6Img,
    title: "其他各种奖品",
  },
]

const Play = () => {
  const blockRef = useRef()
  useEffect(() => {
    const scrollEvent = () => {
      const block = blockRef.current
      if (!block) {
        return
      }
      const top = block.getBoundingClientRect().top
      requestAnimationFrame(() => {
        if (top < 0) {
          block.style.transform = `translate3d(0, ${Math.abs(top) * 0.8}px, 0)`
        } else {
          block.style.transform = "none"
        }
      })
    }
    window.addEventListener("scroll", scrollEvent)
    return () => {
      window.removeEventListener("scroll", scrollEvent)
    }
  }, [])

  const moreGamesTip = (
    <div className={styles.andMore}>
      <p>And More...</p>
      <p>更多游戏即将公布，以上排名不分先后</p>
    </div>
  )
  return (
    <Block
      id="play"
      title={[playTitleImg, playTitleAppImg]}
      className={styles.block}
      append={
        <>
          <img className={styles.bg} src={bgImg} ref={blockRef} alt="" />
          <div className={styles.bgMask} />
        </>
      }
    >
      <Box transitionBg>
        <BoxTitle
          sub="Game Challenge"
          desc={
            <>
              <p>今年场馆内的玩法分为2条主线：</p>
              <p>
                收集线：由于今年的核聚变 Tour
                的主题是「机组成员的游乐园」，我们结合广州站内的场地布局，将所有游戏挑战和场地图制作成了——「飞行棋
                棋盘」，同时现场依然会有数个游戏挑战，我们为每个游戏挑战设计了一枚「飞行棋
                棋子」，每当你完成一个游戏挑战，将会获得一枚棋子，集齐所有棋子后将收获一套可玩的飞行棋桌游。（广州站也有一枚城市限定棋子哦～）
              </p>

              <p>
                奖品线：另外，每当你完成指定游戏挑战的同时还将获得一枚盖章，完成5个挑战，即可到兑换区换一张刮刮卡，刮开的奖品级别随机，后面就要大家各凭本事了。
              </p>
            </>
          }
        >
          游戏挑战
        </BoxTitle>
        <ResponsiveImage className="mb-sm" pc={rulePcImg} mobile={ruleAppImg} />
        <div className={styles.awardsContainer}>
          <div className={styles.awards}>
            {awards.map(({ image, title }) => {
              return (
                <div key={image}>
                  <CardButton disabled>
                    <img src={image} alt={title} />
                  </CardButton>
                  <p>{title}</p>
                </div>
              )
            })}
          </div>
          <p>注*所有奖品数量有限，先到先得</p>
        </div>
        <Title sub="Games" smallMargin>
          游戏列表
        </Title>
        <ResponsiveImage pc={gamesPcImg} mobile={gamesAppImg} />
        {moreGamesTip}
      </Box>
      <Box transitionBg>
        <BoxTitle
          sub="Indie Games"
          desc="我们一直非常关注独立游戏的发展，也希望每个热爱游戏的玩家都能参与到独立游戏的体验和与制作人交流当中去，你的看法与建议，也是每一位制作人最希望在核聚变得到的信息。"
        >
          独立游戏
        </BoxTitle>
        <Title sub="Games" smallMargin>
          游戏列表
        </Title>
        <ResponsiveImage pc={indiePcImg} mobile={indieAppImg} />
        {moreGamesTip}
      </Box>
      <Box transitionBg>
        <BoxTitle
          sub="BOOOM"
          desc="这里的游戏是在18天限时游戏创作活动上创作出来的，你将体验到最新优化版本、也将体验到游戏团队为游戏定制开发的硬件手柄，还能和开发者面对面聊聊他们的开发经历～"
        >
          BOOOM 游戏试玩
        </BoxTitle>
        <ResponsiveImage pc={booomImg} />
      </Box>
    </Block>
  )
}

export default Play
